export const FailureIcon = ({ color = '#ff3131', stroke = 'white' }) => (
  <svg width='55' height='55' viewBox='0 0 55 55' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='27.5' cy='27.5' r='27.5' fill={color} />
    <path d='M18 18.125L36.75 36.875' stroke={stroke} strokeWidth='3' strokeLinecap='round' />
    <path d='M36.75 18.125L18 36.875' stroke={stroke} strokeWidth='3' strokeLinecap='round' />
  </svg>
)
